export const colorMap = {
    'Confirmed': '#1890ff',
    'Cancel': '#ff4d4f',
    'Paid': '#52c41a',
    'Pending': '#faad14',

    'totalProducts': '#1890ff',
    'totalSales': '#52c41a',
    'categorySales': '#fa541c',
    'customerCount': '#13c2c2',
    'orderCount': '#eb2f96',

    'grossSale': '#1890ff',
    'netSale': '#52c41a',
    'deliveryCharges': '#722ed1',
    'discount': '#faad14',
    'tax': '#ff4d4f',

    'Web': '#1890ff',
    'POS': '#52c41a',
    'Call': '#faad14',

    'CASH': '#52c41a',
    'CARD': '#1890ff',
    'Not Specified': '#d9d9d9',

    'DHA': '#722ed1',

    'sales': '#fa541c',
    'count': '#13c2c2',

    'default': ['#1890ff', '#52c41a', '#faad14', '#ff4d4f', '#722ed1', '#fa541c', '#13c2c2', '#eb2f96']
};
